import styled from "styled-components";
import Title from "antd/lib/typography/Title";

export const StyledTitle = styled(Title)`
  margin-top: 0;
  padding-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledText = styled.p`
  color: #808080;
`;
